/* eslint-disable no-unused-vars */
import React from 'react';

import { Grid, Stack, Skeleton, Box, Divider } from '@mui/material';

import { COLOR } from '../../../helpers/colors';
import { returnCountArr } from '../../../helpers/functions';

const textBox = (
  <Skeleton
    animation="wave"
    variant="text"
    color={COLOR.PH}
    style={{
      width: '25%',
    }}
  />
);
const imagePlaceholder = (width, height, marginTop) => (
  <Skeleton
    animation="wave"
    variant="rectangular"
    color={COLOR.PH}
    style={{
      width,
      height,
      marginTop,
    }}
  />
);

const ProductDetailsPlaceholder = () => (
  <Box
    sx={{
      marginY: 6,
    }}
  >
    <Grid container item direction="row" justifyContent="space-between">
      <Grid
        container
        item
        direction="row"
        justifyContent="space-between"
        sx={{
          borderBottom: `1px solid ${COLOR.borderColor}`,
        }}
      >
        <Grid item xs={12} sm={8}>
          {textBox}
          {textBox}
        </Grid>
        <Grid
          item
          container
          xs={12}
          sm={3}
          md={3}
          sx={{
            marginBottom: 5,
          }}
          justifyContent="flex-end"
          alignItems="flex-end"
        >
          {textBox}
        </Grid>
      </Grid>
      <Grid item xs={12} sm={9} md={9}>
        <Stack direction="row" spacing={2} className="horizontal-scroll">
          {imagePlaceholder(860, 640, 10)}
        </Stack>
        <Stack direction="row" spacing={2} className="horizontal-scroll">
          {[0, 1, 2, 3].map(d => (
            <Skeleton
              animation="wave"
              key={d}
              variant="rectangular"
              color={COLOR.PH}
              style={{
                width: 100,
                height: 75,
                marginTop: 10,
              }}
            />
          ))}
        </Stack>
      </Grid>
      <Grid
        item
        xs={12}
        sm={3}
        md={3}
        sx={{
          marginTop: '10px',
          border: `1px solid ${COLOR.borderColor}`,
          borderRadius: 1,
          height: 140,
        }}
      >
        <Grid
          container
          item
          direction="column"
          justifyContent="flex-start"
          alignItems="stretch"
          sx={{
            mb: 2,
            marginLeft: '2px',
          }}
        >
          <Grid item>
            <Skeleton animation="wave" variant="text" width="70%" height={24} />
          </Grid>
          <Grid item>
            <Skeleton animation="wave" variant="text" width="70%" height={24} />
          </Grid>
          <Grid item>
            <Skeleton animation="wave" variant="text" width="70%" height={24} />
          </Grid>
        </Grid>
        <Skeleton
          animation="wave"
          variant="rectangular"
          width="100%"
          height={32}
          sx={{ marginBottom: 2 }}
        />
      </Grid>
    </Grid>
  </Box>
);

export default ProductDetailsPlaceholder;
